import React from 'react'
import ImageStore from '../../../stores/image-store'
import OrderStore from '../../../stores/order-store'
import AdobeAnalytics from '../../../utils/adobe-analytics'
import ProductItemHeader from './product-list-item-header'
import ProductItemDuplicate from './product-list-item-duplicate'
import ProductSelector from './product-selector'
import ProductItemDetailed from '../detailed/container'
import ProductThumbnail from './product-list-thumbnail'
import ProductItemInformation from './product-list-item-information'
import ProductQuantityInput from '../../utils/quantity-input'
import SelectorActions from '../../../actions/selector-actions'
import PriceFormatter from '../../../utils/price-formatter'
import UploadActions from '../../../actions/upload-actions'
import OpeImagePhotoorganiser from '../../../objects/opeimage/photoorganiser'
import PhotoorganiseActions from '../../../actions/photoorganise-actions'
import CSSTransition from 'react-addons-css-transition-group'
import Timer from "../../../utils/timer"
import createReactClass from 'create-react-class'
import {getPercentage} from "../../../utils/percentage";

var ProductListItem = createReactClass({
    mounted: false,

    getInitialState: function () {
        // Set the editExpanded to false. This will toggle the detailed view of each product item
        return {
            thumbImageSrc: null,
            productIsLoaded: false,
            showRemoveConfirmation: false,
            editExpanded: false
        };
    },

    componentDidMount: function () {
        var self = this;
        self.mounted = true;

        //Asyncronously check if product data is available in the OpeOrderItem object
        //Product data might not be available on first try since it might be fetched asyncronusly
        //This is especially true for images being uploaded, since it takes some time to fetch the image data
        //one needs to calculate which product should be applied to the image.
        //Update state when productData is available so that the component will rerender
        function getProductData() {
            if (self.props.item.getProductId() == null) {
                Timer.set("PLIMount", getProductData.bind(self), 500);
            } else if (self.mounted) {
                self.setState({productIsLoaded: true});
            }
        }

        getProductData();
    },
    componentDidUpdate: function (prevProps, prevState) {
        //Scroll page to view item if the user just hit the edit button
        if (prevState.editExpanded === false && this.state.editExpanded === true) {
            $('html, body').animate({
                scrollTop: $("#ope-editor-detailed_" + this.props.item.getId()).offset().top
            }, 1000);
        }
        if (prevState.editExpanded === true && this.state.editExpanded === false) {
            $('html, body').animate({
                scrollTop: $("#ope-order-item_" + this.props.item.getId()).offset().top
            }, 1000);
        }

    },
    clickHandler: function (event) {
        //Remove autocrop warning, since customer now has seen the image with crop
        SelectorActions.setAutoCropWarning(this.props.item.getId(), false);

        //Handle click on edit button
        this.props.editHandler(event, this);
    },
    updateQuantityHandler: function (quantity) {
        //This will update the item quantity in the order store
        SelectorActions.setItemQuantity(this.props.item.getId(), quantity);
    },

    clickDoneHandler: function (event) {
        this.props.closeHandler(event, this);
    },

    batchSelectHandler: function (event) {
    },

    handleHeaderClick: function (event) {
        var instance = this;
        this.state.editExpanded && this.state.productIsLoaded ?
            this.clickDoneHandler(event, instance) :
            this.clickHandler(event, instance);
    },

    _stopPropogation: function (event) {
        event.stopPropagation();
    },

    getItemPrice: function () {
        if (this.props.item.getProductId()) {
            return this.props.item.getPrice();
        }
        return null;
    },

    getItemBasePrice: function () {
        if (this.props.item.getProductId()) {
            return this.props.item.getBasePrice();
        }
        return null;
    },

    duplicateOrderItem: function () {
        SelectorActions.duplicateOrderItem(this.props.item.getId());
    },

    // Function for removing the orderItem from the order-list
    removeOrderItem: function (event) {
        event.stopPropagation();
        this._removeImageFromPhotoorganiserImported(this.props.item);

        //Check if this item is the only item that has the given image
        var orderItemCount = OrderStore.getItemCountByImageId(this.props.item.getImageId());
        if (orderItemCount == 1) {
            UploadActions.removeImageFromStore(this.props.item.getImageId());
        }
        //Remove item
        SelectorActions.removeOrderItem(this.props.item);
    },

    /**
     * This function will check if the image associated with the about-to-be-deleted order item
     * is an instance of OpeImagePhotoorganiser, and if it is, then it will check if
     * other order items also have an reference to the same image. If only one reference is found
     * then the image can no longer be marked as "Imported" in the photoorganiser because it is about
     * to be removed. So then we unmark it as imported.
     * @param  {string} itemId
     */
    _removeImageFromPhotoorganiserImported: function (item) {

        var image = ImageStore.getImageById(item.getImageId());
        var itemList = OrderStore.getItems();
        var count = 0;
        if (image instanceof OpeImagePhotoorganiser) {
            for (var i = 0; i < itemList.length; i++) {
                var checkImage = ImageStore.getImageById(itemList[i].getImageId());
                if (checkImage instanceof OpeImagePhotoorganiser && checkImage.getId() === image.getId()) {
                    count++;
                }
            }
        }
        if (count === 1) {
            PhotoorganiseActions.toggleImageImported(image.getId());
        }
    },

    toggleRemoveConfirmation: function (event) {
        event.stopPropagation();
        this.setState({showRemoveConfirmation: !this.state.showRemoveConfirmation});
    },
    render: function () {
        var item = this.props.item,
            headerClassName = this.state.editExpanded ? 'ope-product-list__item__header row ope-product-list__item__header--expanded' : 'ope-product-list__item__header row';

        const price = this.getItemBasePrice();
        const discountedPrice = this.getItemPrice();
        const discount = getPercentage(discountedPrice, price);
        const priceClass = "price" + (discountedPrice && discount > 0 ? " discounted" : "");

        // If batch is expanded add batch-expanded class to item
        this.props.batchExpanded ? headerClassName += ' ope-product-list__item__header--batch-expanded' : '';

        return (
            <section className="ope-product-list__item" id={"ope-order-item_" + item.getId()}>

                <ProductItemHeader className={headerClassName} expanded={this.state.editExpanded}
                                   id={"ope-product-list__item__header_" + this.props.item.getId()}
                                   item={this.props.item}>

                    <ProductThumbnail
                        className="ope-product-list__item__thumbnail small-5 medium-2 columns ope-grid-column-nopadding"
                        item={item} expanded={this.state.editExpanded} batchExpanded={this.props.batchExpanded}
                        inBatch={this.props.inBatch}
                        editCallback={this.clickHandler}/>

                    <div className="small-4 medium-5 columns ope-grid-column-nopadding">
                        <div className="small-12 medium-6 columns ope-grid-column-nopadding">
                            <div className="ope-product-list__item__sizeLabel medium-1">{_("Size:")}</div>
                            <ProductSelector
                                className="small-12 medium-12 columns ope-product-list__item__product ope-grid-column-nopadding"
                                item={item} productIsLoaded={this.state.productIsLoaded}/>
                        </div>
                        <ProductItemInformation
                            className="ope-product-list__information small-12 medium-6 columns ope-grid-column-nopadding"
                            id={"ope-product-list__information_" + this.props.item.getId()}
                            showLowResWarning={item.getLowResWarning()}
                            showAutoCropWarning={item.getAutoCropWarning()}/>
                    </div>

                    <div className="ope-product-list__item__quantitylabel medium-1">{_("Quantity:")}</div>
                    <ProductQuantityInput callback={this.updateQuantityHandler} value={item.getQuantity()}
                                          wrapperClassName="ope-product-list__item__quantity small-3 medium-1 columns ope-grid-column-nopadding"
                                          quantityClassName="ope-quantity ope-quantity--order-item"
                                          removeHandler={this.removeOrderItem}
                                          onClick={this._stopPropogation}/>

                    <div
                        className="ope-product-list__item__price small-0 medium-1 columns ope-grid-column-nopadding">
                        <div className={priceClass}>{PriceFormatter(discountedPrice ? discountedPrice : price)}</div>
                    </div>

                    <div>
                        <ProductItemDuplicate
                            className="small-12 medium-12 columns ope-product-list__item__duplicate"
                            itemId={this.props.item.getId()}/>
                    </div>

                    <div className="small-0 medium-1 columns ope-grid-column-nopadding ope-product-list__item__delete">
                        {this.state.showRemoveConfirmation ?
                            <div className="ope-product-list__item__delete__confirm">
                                <div>{_("Delete?")}</div>
                                <span onClick={this.removeOrderItem}>{_("Yes")}</span> | <span
                                onClick={this.toggleRemoveConfirmation}>{_("No")}</span>
                            </div>
                            :
                            <span className="ope-icon ope-icon--delete" onClick={this.toggleRemoveConfirmation}></span>
                        }
                    </div>



                    <div className="small-0 medium-1 columns ope-grid-column-nopadding ope-product-list__item__edit">
                        <span onClick={this.clickHandler}>{_("Edit")}</span>
                    </div>

                </ProductItemHeader>

                {this.state.editExpanded ?
                    <CSSTransition transitionName="example" transitionAppear={true} transitionAppearTimeout={500}
                                   transitionEnterTimeout={500} transitionLeaveTimeout={300}>
                        <ProductItemDetailed item={item} saveCallback={this.handleHeaderClick}/>
                    </CSSTransition>
                    : null}
            </section>
        );
    },
    componentWillUnmount: function () {
        this.mounted = false;
    }
});

export default ProductListItem;